import { CustomDatePickerProps } from '@utils/types';
import { Datepicker } from 'flowbite-react';

const CustomDatePicker = ({
  className,
  date,
  setDate,
  minDate,
  maxDate,
  placement = 'left',
}: CustomDatePickerProps) => {
  const styleProps = {
    root: {
      base: 'relative',
    },
    popup: {
      root: {
        base: `xl:absolute xl:-top-16 right-0 sm:justify-center flex xl:scale-75 ${placement === 'left' && 'xl:-left-80'} z-50 block pt-2`,
        inline: 'relative top-10 z-auto',
        inner:
          'inline-block rounded-lg bg-white p-4 shadow-lg dark:bg-gray-700',
      },
      header: {
        base: '',
        title:
          'px-2 py-3 text-center font-semibold text-gray-900 dark:text-white',
        selectors: {
          base: 'mb-2 flex justify-between',
          button: {
            base: 'rounded-lg bg-white px-5 py-2.5 text-sm font-semibold text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:bg-gray-700 dark:text-white dark:hover:bg-gray-600',
            prev: '',
            next: '',
            view: '',
          },
        },
      },
      view: {
        base: 'p-1',
      },
      footer: {
        base: 'mt-2 flex space-x-2',
        button: {
          base: 'w-full rounded-lg px-5 py-2 text-center text-sm font-medium focus:ring-4 focus:ring-cyan-300',
          today:
            'bg-black text-white hover:bg-cyan-800 dark:bg-cyan-600 dark:hover:bg-cyan-700',
          clear:
            'border border-gray-300 bg-white text-gray-900 hover:bg-gray-100 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:hover:bg-gray-600',
        },
      },
    },
    views: {
      days: {
        header: {
          base: 'mb-1 grid grid-cols-7',
          title:
            'h-6 text-center text-sm font-medium leading-6 text-gray-500 dark:text-gray-400',
        },
        items: {
          base: 'grid w-64 grid-cols-7',
          item: {
            base: 'block flex-1 cursor-pointer rounded-lg border-0 text-center text-sm font-semibold leading-9 text-gray-900 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-600',
            selected: 'bg-sky-primary text-white hover:bg-cyan-600',
            disabled: 'text-gray-500',
          },
        },
      },
      months: {
        items: {
          base: 'grid w-64 grid-cols-4',
          item: {
            base: 'block flex-1 cursor-pointer rounded-lg border-0 text-center text-sm font-semibold leading-9 text-gray-900 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-600',
            selected: 'bg-sky-primary text-white hover:bg-cyan-600',
            disabled: 'text-gray-500',
          },
        },
      },
      years: {
        items: {
          base: 'grid w-64 grid-cols-4',
          item: {
            base: 'block flex-1 cursor-pointer rounded-lg border-0 text-center text-sm font-semibold leading-9 text-gray-900 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-600',
            selected: 'bg-sky-primary text-white hover:bg-cyan-600',
            disabled: 'text-gray-500',
          },
        },
      },
      decades: {
        items: {
          base: 'grid w-64 grid-cols-4',
          item: {
            base: 'block flex-1 cursor-pointer rounded-lg border-0 text-center text-sm font-semibold leading-9 text-gray-900 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-600',
            selected: 'bg-sky-primary text-white hover:bg-cyan-600',
            disabled: 'text-gray-500',
          },
        },
      },
    },
  };

  const handleChage = (selectedDate: Date) => {
    setDate(selectedDate);
  };

  return (
    <Datepicker
      className={className}
      theme={styleProps}
      defaultDate={new Date(date)}
      onSelectedDateChanged={handleChage}
      minDate={minDate}
      maxDate={maxDate}
    />
  );
};

export default CustomDatePicker;
